import {
	loginData,
	responseToken,
	responseUserMe,
	responseUsersByProject,
	searchData,
	responseSearchUser,
	addUserData,
	removeUserData,
	addExternalUserData, changePasswordData
} from './transform/UserTransform';
import {handlerError, ApiService} from "../ApiService";
import {notification} from "antd";
import {showAuthMessage} from "../../../redux/actions/Auth";
import {MOCK} from "../../../configs/AppConfig";

const UserService = {};

UserService.login = (data) => {
	if (MOCK) return Promise.resolve({ data: { token: 'mock-jwt-token-1234' } }).then(responseToken);
	return ApiService.post('', loginData(data))
		.then(responseToken)
		.catch(handlerErrorLogin);
}

UserService.getUserMe = () => {
	if (MOCK) return Promise.resolve({ data: {
		id: 1,
		usuario: 'mock_user',
		datos_usuario: { nombre: 'Mock', apellidos: 'Usuario' },
		roles: []
	}}).then(responseUserMe);
	return ApiService.post('', { tipo: "OPERACION_1-2" })
		.then(responseUserMe)
		.catch(handlerError);
}

UserService.getUsersByProject = () => {
	if (MOCK) return Promise.resolve({ data: { roles: [], usuarios: [] } }).then(responseUsersByProject);
	return ApiService.post('', {tipo: "OPERACION_13-1"})
		.then(responseUsersByProject)
		.catch(handlerError)
}

UserService.searchUser = (data) => {
	if (MOCK) return Promise.resolve({ data: { usuarios: [
		{ cuenta_usuario: 'mock_user', nombre_completo: 'Mock Usuario', email: 'mock@hospital.es' }
	]}}).then(responseSearchUser);
	return ApiService.post('', searchData(data))
		.then(responseSearchUser)
		.catch(handlerError)
}

UserService.addUser = (data) => {
	if (MOCK) return Promise.resolve({ data: {} });
	return ApiService.post('', addUserData(data))
		.catch(handlerError)
}

UserService.addExternalUser = (data) => {
	if (MOCK) return Promise.resolve({ data: {} });
	return ApiService.post('', addExternalUserData(data))
		.catch(handlerError)
}

UserService.changePassword = (data) => {
	if (MOCK) return Promise.resolve({ data: {} });
	return ApiService.post('', changePasswordData(data))
		.catch(handlerError)
}

UserService.removeUser = (data) => {
	if (MOCK) return Promise.resolve({ data: {} });
	return ApiService.post('', removeUserData(data))
		.catch(handlerError)
}

export const handlerErrorLogin = (error) => {
	let notificationParam = { message: '' };

	// Remove token and redirect
	if (error.response.status === 401) {
		notificationParam.message = 'Authentication Fail';
		notificationParam.description = 'Please login again';
	}

	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam);
	showAuthMessage(notificationParam.message);

	return Promise.reject(error);
};

export default UserService